export default "__VITE_ASSET__SnS69Iio__"